/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoRefundStatusCallbackDto
 */
export interface WebApiIntegrationsDtoRefundStatusCallbackDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    paymentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    paymentOrderId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    refundedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundStatusCallbackDto
     */
    status?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoRefundStatusCallbackDto interface.
 */
export function instanceOfWebApiIntegrationsDtoRefundStatusCallbackDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoRefundStatusCallbackDtoFromJSON(json: any): WebApiIntegrationsDtoRefundStatusCallbackDto {
    return WebApiIntegrationsDtoRefundStatusCallbackDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoRefundStatusCallbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoRefundStatusCallbackDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'paymentId': !exists(json, 'payment_id') ? undefined : json['payment_id'],
        'paymentOrderId': !exists(json, 'payment_order_id') ? undefined : json['payment_order_id'],
        'refundedAt': !exists(json, 'refunded_at') ? undefined : (new Date(json['refunded_at'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function WebApiIntegrationsDtoRefundStatusCallbackDtoToJSON(value?: WebApiIntegrationsDtoRefundStatusCallbackDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currency': value.currency,
        'id': value.id,
        'payment_id': value.paymentId,
        'payment_order_id': value.paymentOrderId,
        'refunded_at': value.refundedAt === undefined ? undefined : (value.refundedAt.toISOString()),
        'status': value.status,
    };
}

